/** 画面ごとのグループ一覧（左）。絞り込み後の件数と、変更済みの数を出す */

import type { AiUsageGroup, AiUsageItem } from '@/api/types/ai-usages'
import { cn } from '@/lib/utils'

export const ALL_GROUPS = 'all'

type Props = {
  groups: AiUsageGroup[]
  items: AiUsageItem[]
  selected: string
  onSelect: (group: string) => void
}

const Row = ({
  label,
  count,
  changed,
  active,
  onClick,
}: {
  label: string
  count: number
  changed: number
  active: boolean
  onClick: () => void
}) => (
  <button
    type="button"
    aria-current={active ? 'true' : undefined}
    disabled={count === 0}
    onClick={onClick}
    className={cn(
      'flex w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-left text-sm transition-colors',
      active ? 'bg-primary/15 font-medium text-foreground' : 'text-muted-foreground hover:bg-accent/50',
      count === 0 && 'cursor-not-allowed opacity-40 hover:bg-transparent',
    )}
  >
    <span className="truncate">{label}</span>
    <span className="flex shrink-0 items-center gap-1.5 text-xs tabular-nums">
      {changed > 0 && (
        <span title="変更済み" className="rounded-full bg-amber-500/20 px-1.5 text-amber-600 dark:text-amber-400">
          {changed}
        </span>
      )}
      {count}
    </span>
  </button>
)

export const AiUsageSidebar = ({ groups, items, selected, onSelect }: Props) => (
  <nav aria-label="画面" className="space-y-0.5">
    <Row
      label="すべて"
      count={items.length}
      changed={items.filter((item) => item.customized).length}
      active={selected === ALL_GROUPS}
      onClick={() => onSelect(ALL_GROUPS)}
    />
    <div className="my-2 border-t" />
    {groups.map((group) => {
      const inGroup = items.filter((item) => item.group === group.key)
      return (
        <Row
          key={group.key}
          label={group.label}
          count={inGroup.length}
          changed={inGroup.filter((item) => item.customized).length}
          active={selected === group.key}
          onClick={() => onSelect(group.key)}
        />
      )
    })}
  </nav>
)
